exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n  display: block;\n  position: relative; }\n\ninput {\n  display: none; }\n\n.draggable-image-area {\n  position: absolute;\n  height: 100%;\n  width: 100%; }\n  .draggable-image-area.drop-state {\n    border: 2px dashed #babbc7;\n    border-radius: 3px;\n    left: -2px;\n    margin-right: -4px;\n    margin-bottom: -4px;\n    top: -2px;\n    width: 101%; }\n    .draggable-image-area.drop-state .drag-overlay {\n      display: block;\n      opacity: 1; }\n\n.drag-overlay {\n  background-color: rgba(255, 255, 255, 0.9);\n  pointer-events: none;\n  opacity: 0;\n  transition: opacity 0.2s;\n  position: absolute;\n  top: 0;\n  width: 100%;\n  height: 100%; }\n  .drag-overlay b {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate3d(-50%, -50%, 0);\n    font-weight: 500;\n    font-size: 14px;\n    text-align: center;\n    color: #5B6779;\n    line-height: 20px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/shared/components/draggable-image-wrapper/draggable-image-wrapper.component.scss
// module id = ../../../../../src/app/shared/components/draggable-image-wrapper/draggable-image-wrapper.component.scss
// module chunks = 12